import React from 'react'
import { Display, ButtonsGroup, Button } from '@brainstud/react-helpers'
import withTour from './withTour'
import TourBase from './TourBase'
import DevMode from './DevMode'
import Hotspot from '../shared/hotspot/Hotspot'
import styles from './TourWidget.module.css'

const tooltipPositions = {
  right: styles['has-position-right'],
  left: styles['has-position-left'],
  bottom: styles['has-position-bottom'],
  top: styles['has-position-top'],
}

class TourWidget extends React.Component {
  static defaultProps = {
    devMode: false,
    data: null,
    image: null,
    onUpdate: () => {},
    onSubmit: () => {},
    buttonOverviewShow: null,
    buttonOverviewHide: null,
  }

  constructor(props) {
    super(props)

    const steps = []
    let intro = null
    let summary = null

    React.Children.map(props.children, (child) => {
      switch(child.type.displayName) {
        case 'TourSteps':
          React.Children.map(child.props.children, (stepChild) => {
            if(stepChild && stepChild.type.displayName === 'TourStep') {
              steps.push({
                ...stepChild.props,
              })
            }
          })
          break

        case 'TourIntro':
          intro = child
          break

        case 'TourSummary':
          summary = child
          break
      }
    })

    this.props.tour.init({
      steps,
      intro,
      summary,
    })
  }

  render() {
    const { tour, buttonOverviewShow, buttonOverviewHide } = this.props
    const { state: { current } } = tour
    const tooltip = current.tooltip || {}
    const mask = current.mask || {}
    const image = current.image || {}

    return (
      <>
        <TourBase image={this.props.image}>
          {loadedImage => (
            <>
              <div className={`tour-background-el ${styles.background}`}>
                <img src={this.props.image} style={{
                  transform: `
                    scale(${image.zoom})
                    translate3d(${image.center[0]}%,${image.center[1]}%,0)
                  `,
                }} />
              </div>
              <div className={`tour-foreground-el ${styles.foreground}`}>
                <Display if={!tour.state.introVisible && !tour.state.summaryVisible}>
                  <Display if={tour.state.layersVisible || tour.state.singleStep}>
                    <div className={`tour-steps-el ${styles.steps}`}>
                      <div className={`tour-mask-el ${styles.mask}`} style={mask}>
                        <Display if={tour.state.tooltipVisible}>
                          <div className={`tour-tooltip-el ${styles.tooltip} ${tooltipPositions[tooltip.position]}`} style={current.style}>
                            <div className={styles.tooltipContent}>
                              {current.children}
                            </div>

                            <Display if={!tour.state.singleStep}>
                              <div className={styles.tooltipFooter}>
                                <ButtonsGroup right>
                                  <Button
                                    simple
                                    onClick={tour.handlePrevStep}
                                    disabled={tour.isFirstStep}
                                    label="Vorige"
                                    icon="arrow-left"
                                    classNames={{
                                      [styles.prevButton]: true,
                                      [styles.addHover]: true
                                    }}
                                  />
                                  <Button
                                    simple
                                    onClick={tour.handleNextStep}
                                    disabled={tour.isLastStep}
                                    label="Volgende"
                                    icon="arrow-right"
                                    iconPos="right"
                                    classNames={{
                                      [styles.addHover]: true
                                    }}
                                  />
                                </ButtonsGroup>
                              </div>
                            </Display>
                          </div>
                        </Display>
                      </div>
                      <Display if={!tour.state.singleStep}>
                        <div className={`tour-progress-el ${styles.progress}`}>
                          <div className={`tour-progress-track-el ${styles.progressTrack}`}>
                            <div className={`tour-progress-value-el ${styles.progressValue}`} style={{ width: `${tour.progressValue}%` }} />
                          </div>
                        </div>
                      </Display>
                    </div>
                  </Display>
                </Display>
                
                <Display if={!tour.state.layersVisible && !tour.state.singleStep}>
                  <div className={`tour-overview-el ${styles.overview} ${styles.overlayBackground}`}>
                    {tour.steps.map((step, idx) => (
                      <div key={idx}>
                        {step.indicator ? (
                          React.cloneElement(
                            step.indicator,
                            { onClick: () => tour.handleGoToStep(idx) }
                          )
                        ) : (
                          <Hotspot
                            style={{
                              left: `calc(${step.mask.left} + (${step.mask.width} / 2))`,
                              top: `calc(${step.mask.top} + (${step.mask.height} / 2))`,
                            }}
                            onClick={() => tour.handleGoToStep(idx)}
                          />
                        )}
                      </div>
                    ))}
                  </div>
                </Display>

                <div className={`tour-overlay-el ${styles.overlay}`}>
                  <Display if={!tour.state.introVisible && !tour.state.summaryVisible}>
                    <div className={`tour-button-el ${styles.overlayButton}`}>
                      <Display if={tour.state.layersVisible}>
                        {buttonOverviewShow ? (
                          React.cloneElement(
                            buttonOverviewShow,
                            { onClick: tour.handleLayers }
                          )
                        ) : (
                          <Button
                            inversed
                            onClick={tour.handleLayers}
                            label="Bekijk volledige model"
                            icon="tour"
                            iconPos="left"
                          />
                        )}
                      </Display>
                      <Display if={!tour.state.layersVisible}>
                        {buttonOverviewHide ? (
                          React.cloneElement(
                            buttonOverviewHide,
                            { onClick: tour.handleLayers }
                          )
                        ) : (
                          <Button
                            inversed
                            onClick={tour.handleLayers}
                            label="Sluiten"
                            icon="close"
                            iconPos="right"
                          />
                        )}
                      </Display>
                    </div>
                  </Display>

                  <Display if={tour.state.introVisible && tour.intro}>
                    <div className={`tour-modal-el ${styles.overlayModal}`}>
                      <div className={styles.modalContent}>
                        {tour.intro}
                      </div>

                      <div className={styles.modalFooter}>
                        <Button
                          primary
                          square
                          onClick={tour.handleStart}
                          label={tour.steps.length === 0 ? 'No steps' : 'Start'}
                          disabled={tour.steps.length === 0}
                        />
                      </div>
                    </div>
                    <div className={`tour-background-el ${styles.overlayBackground}`} />
                  </Display>

                  <Display if={tour.state.summaryVisible && tour.summary}>
                    <div className={`tour-modal-el ${styles.overlayModal}`}>
                      <div className={styles.modalContent}>
                        {tour.summary}
                      </div>

                      <div className={styles.modalFooter}>
                        <ButtonsGroup full>
                          <Button
                            simple
                            onClick={tour.handleRestart}
                            label="Bekijk nogmaals"
                            icon="reload"
                            classNames={{
                              [styles.addHover]: true
                            }}
                          />
                          <Button onClick={tour.handleFinish} label="Naar oefening" icon="arrow-right" iconPos="right" />
                        </ButtonsGroup>
                      </div>
                    </div>
                    <div className={`tour-background-el ${styles.overlayBackground}`} />
                  </Display>
                </div>
              </div>
            </>
          )}
        </TourBase>

        {this.props.devMode &&
          <DevMode
            state={tour.state}
            onBackgroundChange={(center, zoom) => this.setState({ center, zoom })}
            onMaskChange={() => {}}
          />
        }
      </>
    )
  }
}

export default withTour(TourWidget)
